// Browser-installation identity, not a hardware fingerprint. Keep separate from
// session storage so logout does not reset the signup quota. Cookie/localStorage
// copies recover each other if just one storage mechanism is cleared.
const KEY = 'serviceemp_signup_device_v1';
const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const getSignupDeviceId = () => {
  let saved = '';
  let cookie = '';
  try { saved = window.localStorage.getItem(KEY) || ''; } catch {}
  try {
    cookie = document.cookie.split('; ').find((part) => part.startsWith(`${KEY}=`))?.slice(KEY.length + 1) || '';
  } catch {}
  let id = UUID_V4.test(cookie) ? cookie : UUID_V4.test(saved) ? saved : '';
  if (!id) {
    try {
      const bytes = window.crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
      id = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    } catch { return ''; }
  }
  try { window.localStorage.setItem(KEY, id); } catch {}
  try {
    document.cookie = `${KEY}=${id}; Path=/; Max-Age=34560000; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
  } catch {}
  // Do not silently mint a different ID on every attempt if storage is blocked.
  try { if (window.localStorage.getItem(KEY) === id) return id; } catch {}
  try { if (document.cookie.split('; ').includes(`${KEY}=${id}`)) return id; } catch {}
  return '';
};
